import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.14__e74155461a72bca4a0a50e71b19ff5cb/node_modules/@una-ui/content/layouts/default.vue").then(m => m.default || m))
}